import { SanityImage, SanitySlug } from './sanity'

export enum NewsType {
  ALL = 'all',
  ARTICLE = 'article',
  AUDIO = 'audio',
  VIDEO = 'video',
}

export interface NewsItem {
  _createdAt: string
  _id: string
  _updatedAt: string
  href: string
  translatedHref?: string
  image: SanityImage
  imageBgColor?: { hex: string }
  publishedAt?: Date
  source: string
  title: string
  type: NewsType
}

export enum MediabankAssetType {
  LOGO = 'logo',
}

export interface MediabankAsset {
  _createdAt: string
  _id: string
  _updatedAt: string
  bgStyle: 'light' | 'dark'
  credit: string
  image: SanityImage
  license: string
  slug: SanitySlug
  title: string
  type: MediabankAssetType
}
